import { GridRowParams } from '@material-ui/data-grid';
import React, { useState, useCallback, SyntheticEvent } from 'react';
import Separator from '~/components/Separator';

import { toast } from 'react-toastify';
import api from '~/services/api';
import Search from '~/components/Search';
import { Container } from './styles';
import FormDefault from '~/components/FormDefault';
import ToggleDefault from '~/components/ToggleDefault';
import { InputRadio, InputText } from '~/components/NovosInputs';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { schema } from './validations/schema';

// import useAuth from '~/hooks/useAuth';

const TipoAjusteEstoque: React.FC = () => {
  // const user = useAuth();
  const [showSearch, setShowSearch] = useState<boolean>(true);
  const [isUpdate, setIsUpdate] = useState<boolean>(false);
  const [flgInativo, setFlgInativo] = useState<boolean>(false);
  const [flgInativoNf, setFlgInativoNf] = useState<boolean>(false);
  const [flgAjusteDePara, setFlgAjusteDePara] = useState<boolean>(false);
  const [flgRomaneioForn, setFlgRomaneioForn] = useState<boolean>(false);
  const [codAjuste, setCodAjuste] = useState<number>(0);
  const {
    register,
    handleSubmit,
    control,
    setValue,
    reset,
    watch,
    clearErrors,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    reValidateMode: 'onChange',
  });

  const watchTipoUnidade = watch('tipo_unidade');
  const watchTipoOperacao = watch('tipo_operacao');

  const onRowClick = (param: GridRowParams) => {
    const { row } = param;
    setIsUpdate(true);
    setCodAjuste(row.cod_tipo_ajuste);
    setShowSearch(false);

    setValue('des_ajuste', row.des_ajuste);
    setValue('tipo_unidade', String(row.tipo_unidade));
    setValue('tipo_operacao', String(row.tipo_operacao));
    setFlgInativo(row.flg_inativo);
    setFlgInativoNf(row.flg_ativo_nf);
    setFlgAjusteDePara(row.flg_de_para);
    setFlgRomaneioForn(row.flg_romaneio_fornecedor);
    if (row.des_ajuste) clearErrors('des_ajuste');
  };

  const handleClearForm = useCallback(() => {
    setCodAjuste(0);
    reset();
    clearErrors('des_ajuste');
    setValue('tipo_operacao', '0');
    setValue('tipo_unidade', '0');
    setValue('des_ajuste', '');
    setFlgInativo(false);
    setFlgInativoNf(false);
    setFlgAjusteDePara(false);
    setFlgRomaneioForn(false);
  }, []);

  const onChangeTipoOperacao = useCallback(
    ({ currentTarget: { value } }: SyntheticEvent<any>) => {
      setValue('tipo_operacao', value);
    },
    [],
  );

  const onChangeTipoUnidade = useCallback(
    ({ currentTarget: { value } }: SyntheticEvent<any>) => {
      setValue('tipo_unidade', value);
    },
    [],
  );

  /**
   * Salva ou edita um tipo de ajuste
   */

  const onSave = handleSubmit(async (dataForm) => {
    if (
      dataForm.des_ajuste.trim() === 'NENHUM' ||
      dataForm.des_ajuste.trim() === 'NENHUMA' ||
      dataForm.des_ajuste.trim() === 'NENHUM(A)'
    ) {
      return toast.warn(
        'Descrição contém palavra não permitida "Nenhum/Nenhuma".',
      );
    }
    const tipoAjuste = {
      des_ajuste: dataForm.des_ajuste,
      tipo_operacao: dataForm.tipo_operacao,
      tipo_unidade: dataForm.tipo_unidade,
      flg_inativo: flgInativo,
      flg_ativo_nf: flgInativoNf,
      flg_de_para: flgAjusteDePara,
      flg_romaneio_fornecedor: flgRomaneioForn,
      cod_usuario_cadastro: 3,
      cod_usuario_alteracao: 3,
    };
    /**
     * Verifica se é create ou update e faz a devida chamada na API
     */
    if (isUpdate) {
      const { data } = await api.put(
        `/tipoajusteestoque/${codAjuste}`,
        tipoAjuste,
      );
      if (data.success) {
        toast.success(data.message);
        handleClearForm();
        setShowSearch(true);
      }
      return;
    }
    const { data } = await api.post('/tipoajusteestoque', tipoAjuste);
    if (data.success) {
      toast.success(data.message);
      handleClearForm();
    } else {
      if (!data.success) {
        toast.warning(data.message);
        return;
      }
      throw new Error(data.message);
    }
  });

  /**
   * Inativa um tipo de ajuste
   */
  const handleDelete = useCallback(async () => {
    if (codAjuste === 999 || codAjuste === 998) {
      return toast.warning(
        'Tipo de ajuste de estoque fixo, não permite ser inativado.',
      );
    }
    const { data } = await api.delete(`/tipoajusteestoque/${codAjuste}`);
    const { success, message } = data;
    if (success) {
      toast.success(message);
      setShowSearch(true);
      handleClearForm();
    }
  }, [codAjuste, handleClearForm]);

  const newData = () => {
    handleClearForm();
    setShowSearch(false);
    setIsUpdate(false);
  };

  return (
    <Container>
      {showSearch && (
        <Search codTela={22} newData={newData} onRowClick={onRowClick} />
      )}

      {!showSearch && (
        <FormDefault
          codTela={22}
          title="Tipo de Ajuste de Estoque"
          onSave={async () => {
            await onSave();
          }}
          codigoRegistro={[
            {
              value: codAjuste,
              des_campo: 'Código do Registro',
            },
          ]}
          onCancel={() => setShowSearch(true)}
          isUpdate={isUpdate}
          onNew={newData}
          onDelete={handleDelete}
          labelButtonTrash="Inativar"
          deleteMessage="Deseja realmente inativar o registro?"
          onClearFields={handleClearForm}
          onReturnSearch={() => setShowSearch(true)}
        >
          <div className="row">
            {/* Descrição do Tipo do Ajuste de Estoque */}
            <div className="col-sm-12 col-md-12">
              <InputText
                label="Descrição"
                maxLength={50}
                caseInput="upper"
                placeholder="Informe a Descrição"
                name="des_ajuste"
                register={register}
                control={control}
                isError={!!errors.des_ajuste}
              />
            </div>
          </div>

          <div
            className="row"
            style={{
              marginTop: '10px',
            }}
          >
            {/* Tipo da Operação */}
            <div className="col-sm-12 col-md-12 col-lg-4 d-flex align-items-center">
              <p className="sc-iqHYGH bMXcXH me-2">Tipo de Operação:</p>
              <InputRadio
                value="0"
                label="(+) Entrada"
                name="tipo-operacao"
                register={register}
                isError={false}
                checked={watchTipoOperacao === '0'}
                onChange={onChangeTipoOperacao}
                colorLabel="#313638"
              />

              <InputRadio
                value="1"
                label="(-) Saída"
                name="tipo-operacao"
                register={register}
                isError={false}
                checked={watchTipoOperacao === '1'}
                onChange={onChangeTipoOperacao}
                colorLabel="#313638"
              />
            </div>

            <div
              className="col-sm-12 ml-4 col-md-12 col-lg-4 d-flex align-items-center"
              style={{
                borderLeft: '1px solid #ddd',
              }}
            >
              {/* Tipo da Unidade */}
              <p className="sc-iqHYGH bMXcXH me-2">Tipo de Unidade:</p>
              <InputRadio
                value="0"
                label="UN Venda"
                name="tipo-unidade"
                register={register}
                isError={false}
                checked={watchTipoUnidade === '0'}
                onChange={onChangeTipoUnidade}
                colorLabel="#313638"
              />

              <InputRadio
                value="1"
                label="UN Compra"
                name="tipo-unidade"
                register={register}
                isError={false}
                checked={watchTipoUnidade === '1'}
                onChange={onChangeTipoUnidade}
                colorLabel="#313638"
              />
            </div>
            <div
              className="col-sm-12 col-md-2"
              style={{
                borderLeft: '1px solid #ddd',
              }}
            >
              {/* Inativo */}
              <ToggleDefault
                onSwitch={() => {
                  setFlgInativo(!flgInativo);
                }}
                labelText="Inativo?"
                setChecked={flgInativo}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <Separator labelText="Características" />
            </div>
            <div className="col-2">
              <ToggleDefault
                onSwitch={() => {
                  setFlgInativoNf(!flgInativoNf);
                }}
                labelText="Ativo para NF?"
                setChecked={flgInativoNf}
              />
            </div>
            <div className="col-2">
              <ToggleDefault
                onSwitch={() => {
                  setFlgAjusteDePara(!flgAjusteDePara);
                }}
                labelText="Ajuste De/Para?"
                setChecked={flgAjusteDePara}
              />
            </div>
            <div className="col-2">
              <ToggleDefault
                onSwitch={() => {
                  setFlgRomaneioForn(!flgRomaneioForn);
                }}
                labelText="Romaneio de Fornecedor?"
                setChecked={flgRomaneioForn}
              />
            </div>
          </div>
        </FormDefault>
      )}
    </Container>
  );
};

export default TipoAjusteEstoque;
